import { FC, useEffect, useState } from "react";
import { Logout } from "./Logout";
import { Link } from "react-router-dom";

type MenuItem = {
  id: string;
  label: string;
  icon?: string;
};

type SidebarProps = {
  items: MenuItem[];
  activeItem: string;
  onItemClick: (id: string) => void;
};

export const Sidebar: FC<SidebarProps> = ({
  items,
  activeItem,
  onItemClick,
}) => {
  const [userEmail, setUserEmail] = useState<string | null>(null);

  useEffect(() => {
    // 開発用モック
    setUserEmail("admin@example.com");
  }, []);

  return (
    <div className="w-64 h-screen bg-gray-800 text-white p-4">
      <div className="mb-8 border rounded-md p-2 flex flex-col justify-center items-center gap-4">
        <p className="text-sm text-gray-200 text-center">{userEmail}</p>
        <Logout />
        <Link
          to="/"
          className="px-4 hover:text-blue-300 transition-colors"
        >
          サイトへ戻る
        </Link>
      </div>
      <div className="text-xl font-bold mb-8 px-4">管理画面</div>
      <nav>
        {items.map((item) => (
          <button
            key={item.id}
            onClick={() => onItemClick(item.id)}
            className={`w-full text-left px-4 py-2 rounded mb-2 transition-colors ${activeItem === item.id
                ? "bg-blue-600 text-white"
                : "text-gray-300 hover:bg-gray-700"
              }`}
          >
            {item.label}
          </button>
        ))}
      </nav>
    </div>
  );
};
